// extracted by mini-css-extract-plugin
module.exports = {"SideMenu":"SideMenu_SideMenu__3QcsJ","Open":"SideMenu_Open__2TL9Q"};